import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMixIngredientsGlyphSecondary from './svgs/MixIngredientsGlyphSecondary.js';
import SvgMixIngredientsGlyph from './svgs/MixIngredientsGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var mixIngredientsGlyph = (props => useIcon(SvgMixIngredientsGlyph, SvgMixIngredientsGlyphSecondary, props));

export { mixIngredientsGlyph as default };
